import classes from './CartoonCardImage.module.css';
import CartoonAgeGroup from '../ageGroup/CartoonAgeGroup';
import CartoonDuration from '../duration/CartoonDuration';
import { LanguageContext } from '../../../../../context/LanguageContext';

const CartoonCardImage = (props) => {
  const { cartoonImage, onMouseEnter, onMouseLeave } = props;
  const { ageGroup, duration, isHover, autoPlay } = props;

  const cartoonDurations = (data, lang) => {
    const totalSeconds = Math.floor(duration / 1000);
    let remainingSeconds = totalSeconds;

    const units = [
      { name: 'hours', seconds: 3600 },
      { name: 'minute', seconds: 60 },
      { name: 'seconds', seconds: 1 },
    ];

    const durationArr = [];

    if (data && lang) {
      units.forEach(({ name, seconds }) => {
        const value = Math.floor(remainingSeconds / seconds);
        remainingSeconds = remainingSeconds % seconds;

        durationArr.push({
          time: value,
          type: data[name][lang].slice(0, 1),
          key: data[name]['en'].slice(0, 1),
        });
      });
    }

    return durationArr;
  };

  const durationPartsHandler = (cartoonDurationArr) => {
    const durationParts = cartoonDurationArr
      .filter((item) => item.time > 0)
      .sort((a, b) => a.key.localeCompare(b.key));

    if (durationParts.length === 0) return '';

    const hasHours = durationParts.some((item) => item.key === 'h');

    if (hasHours && durationParts.length >= 2) {
      return `${durationParts[0].time}${durationParts[0].type} ${durationParts[1].time}${durationParts[1].type}`;
    }

    return `${durationParts[0].time}${durationParts[0].type}`;
  };

  return (
    <LanguageContext.Consumer>
      {(ctx) => {
        const cartoonDurationArr = cartoonDurations(ctx.data, ctx.language);
        const cartoonDuration = durationPartsHandler(cartoonDurationArr);

        return (
          <div className={`w-100 position-absolute top-0 ${classes.height_160}`}>
            <div
              className={`position-absolute ${classes.z_index_1000} ${
                isHover
                  ? classes.cartoon_image_hover
                  : !autoPlay
                  ? classes.image_on_mouse_leave
                  : ''
              } ${classes.cursor_pointer}`}
            >
              <div
                className={`${classes.cartoon_image_container} ${classes.border_radius_10} d-flex justify-content-center position-relative`}
                onMouseEnter={onMouseEnter}
                onMouseLeave={onMouseLeave}
              >
                {ageGroup && <CartoonAgeGroup ageGroup={ageGroup} />}
                {cartoonDuration && <CartoonDuration duration={cartoonDuration} />}
                <img
                  className={`${classes.border_radius_10} w-100 h-100`}
                  src={`${process.env.REACT_APP_DEV_URI}${cartoonImage}`}
                  alt=''
                />
              </div>
            </div>
          </div>
        );
      }}
    </LanguageContext.Consumer>
  );
};

export default CartoonCardImage;